'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _InputConstants = require('./InputConstants');

var _lazyEval = require('../utils/lazyEval');

var _lazyEval2 = _interopRequireDefault(_lazyEval);

var _createLazyPropType = require('../utils/propTypes/createLazyPropType');

var _createLazyPropType2 = _interopRequireDefault(_createLazyPropType);

var _ShareInput = require('../decorators/ShareInput');

var _ShareInput2 = _interopRequireDefault(_ShareInput);

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _Functions = require('../core/Functions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var TYPES = ['text', 'email', 'number', 'password', 'search'];

var UITextInput = _react2.default.createClass({
  displayName: 'UITextInput',

  propTypes: {
    _composing: _react.PropTypes.bool,
    className: _react.PropTypes.string,
    defaultValue: _react.PropTypes.string,
    disabled: _react.PropTypes.bool,
    error: _react.PropTypes.bool,
    inputRef: _refObject2.default,
    onChange: _react.PropTypes.func,
    placeholder: (0, _createLazyPropType2.default)(_react.PropTypes.string),
    readOnly: _react.PropTypes.bool,
    styled: _react.PropTypes.bool.isRequired,
    type: _react.PropTypes.oneOf(TYPES),
    use: _react.PropTypes.oneOf(Object.keys(_InputConstants.USE_CLASSES)),
    value: _react.PropTypes.string
  },

  contextTypes: {
    fieldSize: _react.PropTypes.oneOf(Object.keys(_InputConstants.INPUT_SIZE_OPTIONS))
  },

  getDefaultProps: function getDefaultProps() {
    return {
      error: false,
      styled: true,
      type: 'text'
    };
  },
  render: function render() {
    var _props = this.props,
        __composing = _props._composing,
        className = _props.className,
        error = _props.error,
        inputRef = _props.inputRef,
        placeholder = _props.placeholder,
        styled = _props.styled,
        use = _props.use,
        rest = _objectWithoutProperties(_props, ['_composing', 'className', 'error', 'inputRef', 'placeholder', 'styled', 'use']);

    var computedClassName = (0, _reactUtils.classNames)('form-control private-form__control', _InputConstants.INPUT_SIZE_OPTIONS[this.context.fieldSize], className, {
      'private-form__control--unstyled uiTextInputUnstyled': !styled,
      'private-form__control--error': error
    }, _InputConstants.USE_CLASSES[use]);

    return _react2.default.createElement('input', _extends({}, rest, {
      className: computedClassName,
      placeholder: (0, _lazyEval2.default)(placeholder),
      ref: (0, _Functions.wrapRefObject)(inputRef)
    }));
  }
});

exports.default = (0, _ShareInput2.default)(UITextInput);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1552/js/input/UITextInput.js
// module id = 95
// module chunks = 0